export type ClipboardWriteResult = 'copied' | 'failed' | 'unavailable';

export const writeClipboardText = async (value: string): Promise<ClipboardWriteResult> => {
  if (typeof navigator === 'undefined' || !('clipboard' in navigator)) {
    return 'unavailable';
  }

  try {
    await navigator.clipboard.writeText(value);
    return 'copied';
  } catch {
    return 'failed';
  }
};
